<template>
  <cube-page :title="area">
    <div slot="content" v-loading="loading">
      <div id="round">
        <div id="districtDistribution"></div>
      </div>
    </div>
  </cube-page>
</template>
<script>
import { PivotSheet } from '@antv/s2'
import { biData } from '@/api/cube'
import { ValueFormateHandler } from 'wmq-component'
import CubePage from '../../components/cube-page'

export default {
  name: 'DistrictDistribution',
  components: {
    CubePage
  },
  data () {
    return {
      loading: true,
      table: undefined,
      tableOptions: {
        width: 345,
        height: 600,
        style: {
          device: 'mobile'
        },
        'totals': {
          'row': {
            'showGrandTotals': true
          }
        }
      }
    }
  },
  created () {
    this.area = this.$route.query.value + this.$route.query.type
  },
  beforeMount () {
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeHandler)
    this.table.destroy()
  },
  mounted () {
    const yearDate = this.$route.query.year
    const trackId = 'districtDistribution' + this.$route.query.type
    const reqObj = {
      city: this.$route.query.value,
      channelType: this.$route.query.channelType,
      productBrand: this.$route.query.productBrand,
      year: yearDate
    }
    this.loading = true
    biData(trackId, reqObj)
      .then((res) => {
        if (res.code === 1) {
          return res.data
        }
      })
      .then((res) => {
        const container = document.getElementById('districtDistribution')

        res.meta.forEach(item => {
          if (item.format) {
            item.formatter = (value) => {
              return ValueFormateHandler.format(value, item.format)
            }
          }
        })
        const options = JSON.parse(JSON.stringify(this.tableOptions))
        const screenWidth = document.documentElement.clientWidth
        const screenHeight = document.documentElement.clientHeight
        options.height = options.height / 667 * screenHeight
        options.width = options.width / 375 * screenWidth
        this.table = new PivotSheet(container, res, options)

        this.table.render()
      }).finally(() => {
        this.loading = false
      })
  },
  methods: {
    resizeHandler () {
      const self = this
      const screenWidth = document.documentElement.clientWidth
      const screenHeight = document.documentElement.clientHeight
      self.$nextTick(() => {
        self.table.changeSize(self.tableOptions.width / 375 * screenWidth, self.tableOptions.height / 667 * screenHeight)
        self.table.render(false)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
#round{
   margin: 30px
    touch-action: none
  }
</style>
